// Toast styles for different themes and screen sizes
export const toastDarkStyle = {
  background: 'linear-gradient(135deg, rgba(30, 41, 59, 0.98), rgba(17, 24, 39, 0.98))',
  color: '#f8fafc',
  border: '1px solid rgba(100, 116, 139, 0.4)',
  borderRadius: '10px',
  fontSize: '13px',
  fontWeight: '600',
  padding: '12px 16px',
  boxShadow: '0 12px 28px rgba(0, 0, 0, 0.45), 0 6px 12px rgba(0, 0, 0, 0.25)',
  backdropFilter: 'blur(12px)',
  minWidth: '200px',
  maxWidth: '400px',
  textAlign: 'center' as const,
  whiteSpace: 'nowrap' as const,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const toastLightStyle = {
  background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(245, 247, 250, 0.98))',
  color: '#1a202c',
  border: '1px solid rgba(203, 213, 224, 0.8)',
  borderRadius: '10px',
  fontSize: '13px',
  fontWeight: '600',
  padding: '12px 16px',
  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.18), 0 4px 10px rgba(0, 0, 0, 0.08)',
  backdropFilter: 'blur(12px)',
  minWidth: '200px',
  maxWidth: '400px',
  textAlign: 'center' as const,
  whiteSpace: 'nowrap' as const,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const toastDarkStyleMobile = {
  background: 'linear-gradient(135deg, rgba(30, 41, 59, 0.98), rgba(17, 24, 39, 0.98))',
  color: '#f8fafc',
  border: '1px solid rgba(100, 116, 139, 0.4)',
  borderRadius: '8px',
  fontSize: '12px',
  fontWeight: '600',
  padding: '10px 14px',
  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.45), 0 5px 10px rgba(0, 0, 0, 0.25)',
  backdropFilter: 'blur(10px)',
  minWidth: '180px',
  maxWidth: '320px',
  textAlign: 'center' as const,
  whiteSpace: 'nowrap' as const,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const toastLightStyleMobile = {
  background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(245, 247, 250, 0.98))',
  color: '#1a202c',
  border: '1px solid rgba(203, 213, 224, 0.8)',
  borderRadius: '8px',
  fontSize: '12px',
  fontWeight: '600',
  padding: '10px 14px',
  boxShadow: '0 8px 20px rgba(0, 0, 0, 0.18), 0 4px 10px rgba(0, 0, 0, 0.08)',
  backdropFilter: 'blur(10px)',
  minWidth: '180px',
  maxWidth: '320px',
  textAlign: 'center' as const,
  whiteSpace: 'nowrap' as const,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};
